import { FLIGHT_LEVEL } from './constants.js';
import { dom } from './dom.js';
import { calculateSolution } from './geometry.js';
import { state } from './state.js';
import { degToRad, formatCallsign, random } from './utils.js';

export const LEGACY_MIN_CROSSING_ANGLE_DEG = 20;

function getMinimumCrossingAngleDeg(level) {
    return 15 + (5 * level);
}

export function generateScenario(targetDifficulty, rng = Math.random, options = {}) {
    let ac1;
    let ac2;
    let inter;
    let sol;
    let attempts = 0;
    const minimumCrossingAngleDeg =
        options.minimumCrossingAngleDeg ?? getMinimumCrossingAngleDeg(targetDifficulty);

    while (true) {
        attempts++;
        if (attempts > 1000) {
            attempts = 0;
        }

        const angleDeg = random(minimumCrossingAngleDeg, 135, rng);
        const speedDiff = random(0, 100, rng);

        const angleFactor = (1 - Math.cos(degToRad(angleDeg))) / 2;
        const speedFactor = speedDiff / 100;
        const combinedFactor = 0.5 * angleFactor + 0.5 * speedFactor;

        const minCombinedFactor = 0.03;
        const maxCombinedFactor = 0.93;
        const normalizedFactor =
            (combinedFactor - minCombinedFactor) / (maxCombinedFactor - minCombinedFactor);

        const difficultyRating = 1 + 8 * normalizedFactor;

        if (Math.abs(difficultyRating - targetDifficulty) < 0.5) {
            const baseSpeed = random(380, 480, rng);
            const speed1 = Math.round(baseSpeed);
            const speed2 = Math.round(
                baseSpeed + speedDiff * (rng() > 0.5 ? 1 : -1),
            );

            const heading1Rad = degToRad(random(0, 360, rng));
            const heading2Rad = (heading1Rad + degToRad(angleDeg)) % (2 * Math.PI);

            inter = { x: random(-5, 5, rng), y: random(-5, 5, rng) };
            const dist1 = Math.round(random(40, 100, rng));
            const dist2 = Math.round(random(40, 100, rng));

            ac1 = {
                callsign: formatCallsign(rng),
                x: inter.x - dist1 * Math.sin(heading1Rad),
                y: inter.y + dist1 * Math.cos(heading1Rad),
                speed: speed1,
                headingRad: heading1Rad,
                fl: FLIGHT_LEVEL,
            };
            ac2 = {
                callsign: formatCallsign(rng),
                x: inter.x - dist2 * Math.sin(heading2Rad),
                y: inter.y + dist2 * Math.cos(heading2Rad),
                speed: speed2,
                headingRad: heading2Rad,
                fl: FLIGHT_LEVEL,
            };

            sol = calculateSolution(ac1, ac2, inter);

            if (sol.minDistance > 0.1 && sol.minDistance < 15 && sol.timeToCPA > 0) {
                break;
            }
        }
    }

    if (ac2.x < ac1.x) {
        const swapped = ac1;
        ac1 = ac2;
        ac2 = swapped;
        sol = calculateSolution(ac1, ac2, inter);
    }

    state.aircraft1 = ac1;
    state.aircraft2 = ac2;
    state.intersectionPoint = inter;
    state.solution = sol;
    dom.sliderLabelLeft.textContent = ac1.callsign;
    dom.sliderLabelRight.textContent = ac2.callsign;
}
